import { Box, Flex, Grid, Heading, Text } from "@chakra-ui/react";
import { AppLink, Reveal, SectionHead } from "@/components";
import { APPLICATIONS, APPLICATIONS_HEAD, SECTORS, SECTORS_LABEL, SECTORS_LEAD, SECTORS_MORE } from "@/content";

export const Applications = () => (
  <Box as="section" id="applications" maxW="maxw" mx="auto" px="pad" pb="sec">
    <SectionHead head={APPLICATIONS_HEAD} />

    <Grid as="ul" role="list" gap="gap" templateColumns="repeat(auto-fit, minmax(min(100%, 260px), 1fr))">
      {APPLICATIONS.map((application, index) => (
        <Reveal as="li" key={application.id} index={index} listStyleType="none" display="grid">
          <AppLink
            href={application.href}
            external
            data-group
            position="relative"
            display="grid"
            h="100%"
            gridTemplateRows="auto 1fr"
            borderRadius="md"
            overflow="hidden"
            bg="surface.white"
            border="1px solid"
            borderColor="line.hairline"
            transitionProperty="transform, box-shadow, border-color"
            transitionDuration="0.35s"
            transitionTimingFunction="brand"
            _hover={{
              transform: "translateY(-4px)",
              borderColor: "rgba(247, 95, 45, 0.45)",
              boxShadow: "0 18px 40px -28px rgba(0, 0, 0, 0.55)",
              "& img": { transform: "scale(1.04)" },
            }}
          >
            <Box bg="surface.DEFAULT" overflow="hidden">
              <img
                src={application.image.src}
                width={application.image.width}
                height={application.image.height}
                alt={application.image.alt}
                loading="lazy"
                decoding="async"
                style={{
                  width: "100%",
                  aspectRatio: "16 / 10",
                  objectFit: "cover",
                  transition: "transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
                }}
              />
            </Box>

            <Grid p="clamp(18px, 2vw, 24px)" pr="58px" gap="8px" alignContent="start">
              <Heading as="h3" variant="card" fontSize="clamp(1.0625rem, 1.35vw, 1.375rem)" lineHeight={1} minH="2.2em">
                {application.title}
              </Heading>
              <Text fontSize="small" lineHeight={1.35} color="warm.600" sx={{ textWrap: "pretty" }}>
                {application.desc}
              </Text>
            </Grid>

            <Box
              className="print-hide"
              aria-hidden="true"
              position="absolute"
              right="18px"
              bottom="18px"
              w="34px"
              h="34px"
              display="grid"
              placeItems="center"
              borderRadius="50%"
              bg="ink.DEFAULT"
              color="ink.light"
              fontSize="0.9rem"
              transitionProperty="background-color, transform"
              transitionDuration="0.3s"
              transitionTimingFunction="brand"
              _groupHover={{ bg: "brand.500", transform: "translateX(3px)" }}
            >
              →
            </Box>
          </AppLink>
        </Reveal>
      ))}
    </Grid>

    <Flex
      role="group"
      aria-label={SECTORS_LABEL}
      mt="clamp(40px, 5vw, 72px)"
      pt="clamp(24px, 3vw, 40px)"
      borderTop="1px solid"
      borderColor="line.hairline"
      wrap="wrap"
      align="baseline"
      gap="14px clamp(18px, 2.4vw, 32px)"
    >
      <Text as="span" variant="eyebrow">
        {SECTORS_LEAD}
      </Text>
      <Flex as="ul" role="list" wrap="wrap" gap="10px clamp(16px, 2vw, 28px)">
        {SECTORS.map((sector) => (
          <Box as="li" key={sector} fontSize="clamp(1rem, 1.6vw, 1.5rem)" textTransform="uppercase" color="warm.600">
            {sector}
          </Box>
        ))}
        <Box
          as="li"
          fontSize="clamp(1rem, 1.6vw, 1.5rem)"
          textTransform="uppercase"
          color="brand.600"
          fontWeight="medium"
        >
          {SECTORS_MORE}
        </Box>
      </Flex>
    </Flex>
  </Box>
);
